var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col col-8 q-pa-md q-gutter-md"},[_c('CiblesTimeline',{attrs:{"cibles":_vm.cibles,"color":"per"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }